import List from "@/components/list";
import router from "@/router";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  // 考勤详情
  function goClassGroup(data) {
    router.push({
      path: "attendanceDetail",
      query: { classId: data.classId, classChildId:data.classChildId, courseId:data.courseId},
    });
  }
  const Deal = ({ props: { vo } }) => {
    const data = vo.row;
    return (
      <div class="deal-group">
        <el-tooltip
          content="考勤详情"
          placement="top"
          style="margin-right:20px"
        >
          <i class="icon_kaoqinxiangqing_icon"
            onClick={() => goClassGroup(data)}
          ></i>
        </el-tooltip>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "课程名称",
      prop: "courseName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "授课教师",
      prop: "teacherName",
      minWidth: "120"
    },
    {
      label: "教学形式",
      prop: "teachingFrom",
      minWidth: "120"
    },
    {
      label: "上课时间",
      prop: "teachingStartTime",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "课程面向分组",
      prop: "groupNames",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "出勤率(%)",
      prop: "attendance",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "应到人数",
      prop: "shouldNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "出勤",
      prop: "actualNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "迟到",
      prop: "lateNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "早退",
      prop: "earlyNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "事假",
      prop: "affairsNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "病假",
      prop: "sickNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "公假",
      prop: "publicNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "未签",
      prop: "notNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      width: "100",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
